import { useCallback, useState, useEffect } from 'react';
import { Breakpoints, breakpointSizes } from '../constants';
const useMediaQuery = (breakpoint) => {
    const [targetReached, setTargetReached] = useState(false);
    const width = typeof breakpoint === 'number' ? breakpoint : breakpointSizes[breakpoint];
    const updateTarget = useCallback((e) => {
        setTargetReached(e.matches);
    }, []);
    useEffect(() => {
        const media = breakpoint === Breakpoints.XXL
            ? window.matchMedia(`(min-width: ${breakpointSizes.xlarge + 1}px)`)
            : window.matchMedia(`(max-width: ${width}px)`);
        if ((media === null || media === void 0 ? void 0 : media.matches) !== targetReached) {
            setTargetReached(media.matches);
        }
        try {
            media === null || media === void 0 ? void 0 : media.addEventListener('change', updateTarget);
            return () => media === null || media === void 0 ? void 0 : media.removeEventListener('change', updateTarget);
        }
        catch (_a) {
            media === null || media === void 0 ? void 0 : media.addListener(updateTarget);
            return () => media === null || media === void 0 ? void 0 : media.removeListener(updateTarget);
        }
    }, []);
    return targetReached;
};
export default useMediaQuery;
//# sourceMappingURL=useMediaQuery.js.map